import React, { Fragment, useState } from 'react';
import _get from 'lodash/get';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';

import {
  experimentStates,
  setExperimentOverrides,
  getExperimentOverrides,
} from '@zola-helpers/client/dist/es/experiments';

import styles from './FeatureToggle.module.less';
import DropdownV3 from '../Form/dropdownV3';
import { ButtonV3 } from '../ButtonV3';

export const ExperimentFlags = ({ userContext }: { userContext: UserContext }): JSX.Element => {
  const [experiment, setExperiment] = useState<string | null>(null);
  const [overrideVariation, setOverrideVariation] = useState<string | null>(null);

  const experiments = userContext?.user_experiments;
  const sortedExperimentKeys = Object.keys(experiments || {}).sort(
    (a, b) => a.toLowerCase().localeCompare(b.toLowerCase()) // Case-insensitive sort
  );
  const getExperimentOptions = () => {
    return sortedExperimentKeys.map((e) => ({ label: e, value: e }));
  };

  const submitExperimentOverride = () => {
    if (!experiment || !overrideVariation) return; // TODO: add validation to dropdown
    setExperimentOverrides(experiment, overrideVariation);

    window.location.reload();
  };

  const renderExperimentValueTable = () => {
    const storedOverrides = getExperimentOverrides();
    return (
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              <th>Experiment</th>
              <th>Assigned Variation</th>
              <th>Override Variation</th>
            </tr>
          </thead>
          <tbody>
            {sortedExperimentKeys.map((k) => (
              <tr key={k}>
                <th>{k}</th>
                <th>{experiments?.[k].variation_key}</th>
                <th>{_get(storedOverrides, k, '--')}</th>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <Fragment>
      <div className={styles.experiments}>
        <DropdownV3
          id="experimentList"
          options={getExperimentOptions()}
          label="Experiment"
          onSelect={setExperiment}
          value={experiment ?? undefined}
          className={styles.dropdown}
        />
        <div>
          <span className={styles.bold}>Assigned User Variation: </span>
          {_get(userContext, `user_experiments.${experiment}.variation_key`, 'N/A')}
        </div>
        <div>
          <span className={styles.bold}>Current Override Variation: </span>
          {_get(getExperimentOverrides(), `${experiment}`, 'not set')}
        </div>
        <DropdownV3
          id="experimentOverrideVariation"
          options={[
            { label: experimentStates.NOT_IN_TEST, value: experimentStates.NOT_IN_TEST },
            { label: experimentStates.CONTROL, value: experimentStates.CONTROL },
            { label: 'TEST-1', value: 'TEST-1' },
            { label: 'TEST-2', value: 'TEST-2' },
            { label: 'TEST-3', value: 'TEST-3' },
            { label: 'TEST-4', value: 'TEST-4' },
          ]}
          label="Set Override Variation"
          onSelect={setOverrideVariation}
          value={overrideVariation ?? undefined}
          className={styles.dropdown}
          inline
        />
        <ButtonV3 onClick={submitExperimentOverride}>Override Variation And Reload</ButtonV3>
      </div>
      {renderExperimentValueTable()}
    </Fragment>
  );
};
